<div class="[overflow-anchor:none]" data-test-id="filters">
	<div class="flex flex-col gap-3">
		@if (showMapButton()) {
			<vp-filter-map-button (click)="showMap.emit()" />
		}
		<div class="flex flex-row items-center">
			<span class="text-lg font-semibold">
				{{ 'compositions.filters.title' | translate }}
			</span>
			<button
				(click)="clearAllFilters()"
				class="btn ml-auto btn-primary btn-text"
				data-test-id="clear-filters"
			>
				<svg-icon src="assets/icons/icon-delete.svg" />
				{{ 'compositions.filters.clear-all' | translate }}
			</button>
		</div>
		@if (activeFilterChips().length > 0) {
			<div class="mb-3 flex flex-wrap gap-2">
				@for (
					chip of activeFilterChips();
					track chip.group + chip.value
				) {
					<vp-tag
						[clickable]="true"
						(click)="removeFilter(chip.group, chip.value)"
						color="primary"
						data-test-class="active-filter"
						iconTrailing="assets/icons/icon-cross.svg"
					>
						@if (chip.type === 'numeric') {
							{{
								'compositions.filters.type.' + chip.group
									| translate
							}}: {{ chip.value }}
						} @else {
							{{ chip.name }}
						}
					</vp-tag>
				}
			</div>
		}
		<ng-container [ngTemplateOutlet]="divider" />
		<vp-filter-search
			[loading]="searchLoading()"
			[options]="searchOptions()"
			[selectedLabel]="searchLocation()"
			(searched)="onSearched($event)"
			(selected)="onSearchSelected($event)"
		/>
		<ng-container [ngTemplateOutlet]="divider" />
		@for (
			filterGroupItem of filteredFilters();
			track filterGroupItem.title;
			let isLast = $last
		) {
			@switch (filterGroupItem.type) {
				@case ('layout') {
					<vp-filter-layout
						[activeValues]="
							activeFilters()[filterGroupItem.title] ?? []
						"
						[items]="filterGroupItem.items ?? []"
						[title]="filterGroupItem.title"
						(changed)="
							setGroupValues(filterGroupItem.title, $event)
						"
					/>
				}
				@case ('numeric') {
					<vp-filter-numeric
						[inputId]="filterGroupItem.title"
						[maxValue]="filterGroupItem.maxValue"
						[value]="numericValues()[filterGroupItem.title]"
						(changed)="
							setNumericValue(filterGroupItem.title, $event)
						"
					/>
				}
				@default {
					<vp-filter-checkbox-group
						[activeValues]="
							activeFilters()[filterGroupItem.title] ?? []
						"
						[items]="filterGroupItem.items ?? []"
						[itemsLimit]="ITEMS_LIMIT"
						[title]="filterGroupItem.title"
						(changed)="
							setGroupValues(filterGroupItem.title, $event)
						"
					/>
				}
			}
			@if (!isLast) {
				<ng-container [ngTemplateOutlet]="divider" />
			}
		}
	</div>
</div>

<ng-template #divider>
	<hr class="my-3 border-ui-100" />
</ng-template>
